module.exports = __webpack_public_path__ + "img/eye.e378a562.svg";